<template>
  <li
    v-if="member"
    class="member p-3">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div>
          <img
            v-if="member.avatar"
            class="img-fluid rounded-circle member__img mr-3"
            :src="member.avatar">
          <p v-else>
            <span class="material-icons member__icon mr-3">person</span>
          </p>
        </div>
        <div class="member__content">
          <p class="member__name mr-3">
            {{ member.name }}
          </p>
        </div>
        <p
          class="member__title">
          {{ member.position }}
        </p>
      </div>
      <big-check-box
        :id="member.id"
        :checked="_value"
        @input="_value = member.id" />
    </div>
  </li>
</template>

<script>
import BigCheckBox from '@/components/parts/BigCheckBox'

export default {
  components: {
    BigCheckBox
  },
  props: {
    member: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
  },
  computed: {
    _value: {
      get() {
        return this.value.includes(this.member.id)
      },
      set(newMemberId) {
        if (this._value) {
          this.$emit('input', this.value.filter(memberId => memberId !== newMemberId))
          return
        }
        this.$emit('input', [...this.value, newMemberId])
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';
</style>